import React from 'react';
import FreeText from './free_text';
import MultiSelect from '../answer_footer/multi_select';
import { Layout } from 'antd';
import styles from './answer_footer.module.scss';
import { UserResponseType } from '../../models/questionnaire.interface';
import { ConfigProvider } from 'antd';
import { COLORS } from 'themes/colors';

const { Footer } = Layout;

interface AnswerFooterProps {
  type: string;
  questionId: number;
  recordAnswer: (userResponse: UserResponseType) => void;
  isBeingEdited: boolean;
  disabled?: boolean;
}

const AnswerFooter: React.FC<AnswerFooterProps> = ({
  type,
  questionId,
  recordAnswer,
  isBeingEdited,
  disabled = false,
}) => {
  if (type === 'select' || type === 'statement') return <></>;
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorTextDisabled: COLORS.tundoraL2,
            colorBgContainerDisabled: COLORS.tundoraL3,
            colorBgContainer: COLORS.tundoraL3,
            colorText: COLORS.tundoraL0,
          },
        },
      }}
    >
      <Footer className={styles.answerFooter} style={{ padding: '17px 20px' }}>
        {type === 'freeText' && (
          <FreeText
            recordAnswer={recordAnswer}
            questionId={questionId}
            isBeingEdited={isBeingEdited}
            disabled={disabled}
          />
        )}
        {type === 'multiselect' && (
          <MultiSelect
            recordAnswer={recordAnswer}
            questionId={questionId}
            isBeingEdited={isBeingEdited}
            disabled={disabled}
          />
        )}
      </Footer>
    </ConfigProvider>
  );
};

export default AnswerFooter;
